import * as Yup from 'yup'

export const formSchema = Yup.object().shape({
  notes: Yup.string(),
})

export interface FormValuesType {
  attachments?: []
  notes?: string
}
